import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Seo } from "../components/Seo";

export default function DonationCancel() {
  return (
    <>
      <Seo title="Donation Cancelled" path="/donation/cancel" />
      <section className="min-h-[80vh] grid place-items-center px-5 pt-24 pb-16">
        <div className="max-w-lg w-full rounded-3xl bg-white border border-black/5 shadow-warm-lg p-10 sm:p-12 text-center" data-testid="donation-cancel">
          <XCircle size={48} className="mx-auto text-ink-soft" />
          <h1 className="mt-6 font-display text-3xl font-semibold">Donation cancelled</h1>
          <p className="mt-2 text-ink-soft">No charge was made. You can head back and try again any time, we'd love your support!</p>
          <div className="mt-8 flex flex-wrap gap-3 justify-center">
            <Link to="/sponsor-donation" className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-terracotta text-white text-sm font-semibold hover:bg-sienna transition-colors duration-200">
              Back to donate
            </Link>
            <Link to="/" className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full border border-ink/20 text-sm font-semibold hover:border-terracotta hover:text-terracotta transition-colors duration-200">
              Home
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
